function install (Vue) {
  Vue.trackConversion = function (options) {
    window.philips.analytics.trackConversion({
      name: options.name,
      description: options.description,
      servicename: options.servicename,
      url: options.url,
      vouchercode: options.vouchercode
    })
  }

  Vue.prototype.trackConversion = function (options) {
    window.philips.analytics.trackConversion({
      name: options.name,
      description: options.description,
      servicename: options.servicename,
      url: options.url,
      vouchercode: options.vouchercode
    })
  }

  Vue.trackAjax = function (options) {
    window.philips.analytics.trackAjax({
      events: options.events,
      products: options.products,
      type: options.type
    })
  }

  Vue.prototype.trackAjax = function (options) {
    window.philips.analytics.trackAjax({
      events: options.events,
      products: options.products,
      type: options.type
    })
  }
}

const updatePageName = function (pagename) {
  if (pagename) {
    let metaPageName = document.querySelector('[name="PHILIPS.METRICS.PAGENAME"]')
    if (metaPageName) {
      metaPageName.content = pagename
      if (window.s) {
        window.s.pageName = pagename
      }
    }
    if (pagename !== 'subscription_successful') {
      let metaProducts = document.querySelector('[name="PHILIPS.METRICS.PRODUCTS"]')
      let metaEvents = document.querySelector('[name="PHILIPS.METRICS.EVENTS"]')
      if (metaProducts && metaEvents) {
        metaProducts.parentNode.removeChild(metaProducts)
        metaEvents.parentNode.removeChild(metaEvents)
      }
    }
  }
}

export {
  install as trackConversion,
  updatePageName
}
